import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {
		list: [],
	},
	mutations: {
		[MUTATIONS.ACCOUNT_GROUP.CREATE](state, group) {
			state.list.push(group)
		},
		[MUTATIONS.ACCOUNT_GROUP.LIST](state, list) {
			state.list = list
		},
		[MUTATIONS.ACCOUNT_GROUP.DELETE](state, id) {
			let result = state.list.find(d => {
				return d.id === id
			})

			const idx = state.list.indexOf(result)
			if (idx > -1) {
				state.list.splice(idx, 1)
			}
		},
	},
	actions: {
		[ACTIONS.ACCOUNT_GROUP.LIST]({ commit, dispatch, state }, filter = {}) {
			return API.ACCOUNT_GROUP.LIST(filter).then(res => {
				commit(MUTATIONS.ACCOUNT_GROUP.LIST, res)
				return res
			})
		},

		[ACTIONS.ACCOUNT_GROUP.CREATE](
			{ commit, dispatch, state },
			{ name },
		) {
			return API.ACCOUNT_GROUP.CREATE({ name }).then(res => {
				commit(MUTATIONS.ACCOUNT_GROUP.CREATE, res)
				return res
			})
		},

		[ACTIONS.ACCOUNT_GROUP.DELETE]({ commit, dispatch, state }, { id }) {
			return API.ACCOUNT_GROUP.DELETE({ id }).then(res => {
				commit(MUTATIONS.ACCOUNT.REMOVE_GROUP, { id })
				commit(MUTATIONS.ACCOUNT_GROUP.DELETE, id)
				return res
			})
		},
	},

	getters: {
		getAccountGroups: state => state.list,
	},
}
